import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Box } from '@material-ui/core';

import { Hidden } from '€components/Hidden';
import UserSettings from '€components/UserProfile/UserSettings';
import UserDetails from '€components/UserProfile/UserDetails';
import ContentLayout from '€layouts/ContentLayout';
import { Routes } from '€lib/routing';
import PrivacyPolicy from '€components/PrivacyPolicy';
import TermsOfUse from '€components/TermsOfUse';
import PasswordResetForm from '€components/PasswordResetForm';

const UserProfile = () => {
    return (
        <Box display="flex" flexDirection="column">
            <Hidden smDown>
                <ContentLayout.Title
                    mt={0}
                    mb={2}
                    alignSelf="flex-start"
                    textAlign="left"
                    title="Profile"
                    variant="h4"
                />
            </Hidden>
            <Box display="flex" my={2} width="100%">
                <Box minWidth="22rem" display="flex" mr={6}>
                    <UserSettings />
                </Box>
                <Box width="61.3rem">
                    <Switch>
                        <Route path={Routes.UserUpdatePassword}>
                            <PasswordResetForm />
                        </Route>
                        <Route path={Routes.UserPrivacyPolicy}>
                            <PrivacyPolicy />
                        </Route>
                        <Route path={Routes.UserTermsOfUse}>
                            <TermsOfUse />
                        </Route>
                        <Route>
                            <UserDetails />
                        </Route>
                    </Switch>
                </Box>
            </Box>
        </Box>
    );
};

export default UserProfile;
